/**
 * MACRO #31 HOTFIX — Page 3 touch ownership (pure, deterministic).
 *
 * FROZEN INPUT OWNERSHIP: the owner of a touch sequence is decided at the FIRST
 * touch and never changes for the rest of that sequence.
 *   - "grid" → the Grid owns pan/pinch/tap; native page scroll is suppressed
 *     (non-passive preventDefault).
 *   - "page" → the browser scrolls the narrative natively; the Grid does
 *     nothing (no camera, no capture, no manual scroll).
 *
 * Rule:
 *   - already owned → keep it (frozen; a sequence started outside is never
 *     stolen by the Grid, and one started inside keeps the Grid if a finger
 *     wanders out).
 *   - new sequence, 2+ simultaneous touches → "grid" (pinch).
 *   - new sequence, single touch → "grid" iff it started inside the plane,
 *     else "page".
 */
export type TouchSeqOwner = "grid" | "page";

export function decideTouchOwner(
  prev: TouchSeqOwner | null,
  opts: { touchCount: number; firstTouchInsideGrid: boolean },
): TouchSeqOwner {
  if (prev !== null) return prev; // frozen for the whole sequence
  if (opts.touchCount >= 2) return "grid";
  return opts.firstTouchInsideGrid ? "grid" : "page";
}

export function ownerSuppressesNativeScroll(owner: TouchSeqOwner | null): boolean {
  return owner === "grid";
}
